module.exports = __webpack_public_path__ + "static/media/V2_21.88c7282f.png";